import { useNavigate } from 'react-router-dom';

import useTranslations from '@/i18n/useTranslations';
import { createCommunityArtworkNavigationState } from '@/shared/lib/communityArtworkNavigation';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import CardHeader from '@/shared-components/cards/components/CardHeader';
import UserProfileImage from '@/shared-components/cards/components/UserProfileImage';
import Text from '@/shared-components/text/components/Text';
import Utils from '@/utils';

import './styles/NewArtworkCard.css';

export default function NewArtworkCard({ data, actor }) {
  const navigate = useNavigate();
  const t = useTranslations('common.shared.community_feed');
  const claimedArtist  = data?.artwork_about?.artwork_artist;
  const galleryArtist  = data?.artwork_about?.artwork_gallery_artist;
  const artist         = claimedArtist || galleryArtist;

  // Avatar: user image if reclaimed; else the catalog artist profile image (if any)
  const artistImageId  = artist?.user_image?.image_id || artist?.artist_profile_image?.image_id;

  // Name: reclaimed profile display name → catalog name → safe fallback
  const artistName =
    claimedArtist?.user_name ??
    galleryArtist?.artist_name ??
    t('fallbacks.unknown_artist');

  return (
    <div
      className="new-artwork-card__container"
      onClick={() => navigate(`/artwork/${data.slug}`, {
        state: createCommunityArtworkNavigationState(),
      })}
    >
      <CardHeader
        image={actor?.image}
        profileType={actor?.profileType}
        username={actor?.username}
        onUserClick={() => navigate(`/user/${actor?.username}`)}
        timeAgo={Utils.elapsedTime(new Date(data.createdAt).getTime())}
        subtitle={t('activity.artwork')}
      />
      <ArtworkImage
        image={data?.artwork_media?.artwork_main_picture?.image_id}
        imageClassName="new-artwork-card__artwork-image"
        imageTemplateClassName="new-artwork-card__artwork-image"
      />
      <div className="new-artwork-card__artwork-info">
        {artistImageId && (
          <UserProfileImage
            image={artistImageId}
            typeOfProfile="artist"
            className="new-artwork-card__artist-image"
          />
        )}
        <div className="new-artwork-card__artwork-text">
          <Text className="new-artwork-card__artist-name" paragraph>
            {artistName}
          </Text>
          <Text className="new-artwork-card__artwork-title" paragraph>
            {data?.artwork_about?.artwork_title}
          </Text>
        </div>
      </div>
    </div>
  );
}
